import Form, { FormProps } from "@/shared/form/form";
import { FieldsType } from "../mode/types";
import Input from "@/shared/form/input";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";

export function CreateCompanyDocumentConfirmationForActivePersonsForm(
  props: FormProps<FieldsType>,
) {
  return (
    <Form {...props}>
      <Form.Item<FieldsType> name="documentId" hidden>
        <Input />
      </Form.Item>

      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </Form>
  );
}
